import React from 'react';
import { Button, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useBreadcrumbs } from "../../contexts/Breadcrumbs";
import { useUniqueEffect } from "../../hooks";
import { usePrerequisites } from '../../contexts/Prerequisites';


const CommonBreadCurmb = ({ docTitle, breadcrumbs, Component, infoMessage = { isvisible: false, value: '' }, parentFilters = {}, actions = { action: '', route: '' }, handleSubmit, maxCount, message, apiUrl, navigateUrl }) => {
	const [, setBreadcrumbs] = useBreadcrumbs();
	const [{ strings }] = usePrerequisites();
	const navigate = useNavigate();
	const BackButton = () => {
		return (<Button variant='contained' startIcon={<ArrowBackIcon />} onClick={() => { navigate(actions.route) }}>{strings.Back}</Button>)
	}
	const actionsComponent = {
		'goback': BackButton
	}

	useUniqueEffect(() => {
		setBreadcrumbs({ docTitle, breadcrumbs, infoMessage, actions: [{ component: actionsComponent[actions.action] }] })
	}, []);

	return (
		<Grid container>
			<Grid size={12}>
				<Component
					parentFilters={parentFilters}
					onSubmit={(values, { activeRecord, ...param }) => handleSubmit({
						values,
						activeRecord,
						maxCount,
						message,
						apiUrl,
						navigate,
						navigateUrl,
						...param
					})} />
			</Grid>
		</Grid>
	);
}
export default CommonBreadCurmb;